import { gql } from '@apollo/client'
import { BRAND_FRAGMENT } from './BrandFragment'
import { MANUFACTURER_FRAGMENT } from './ManufacturerFragment'
import { PACKAGING_FRAGMENT } from './PackagingFragment'
import { PRODUCT_PRICE_OBJECT_FRAGMENT } from './ProductPriceObjectFragment'

export const PRODUCT_PRICE_FRAGMENT = gql`
  fragment ProductPrice on ProductPrice {
    id
    price
    notAvailable
    priceVisible
    productPriceObject {
      ...ProductPriceObject
    }
  }
  ${PRODUCT_PRICE_OBJECT_FRAGMENT}
  ${PACKAGING_FRAGMENT}
  ${BRAND_FRAGMENT}
  ${MANUFACTURER_FRAGMENT}
`
